import { isClient } from './utils';
export var TrackEvent;
(function (TrackEvent) {
    TrackEvent["CONFRIM_EMAIL"] = "facebook_deprecation_confirmEmail";
    TrackEvent["USE_DIFFERENT_EMAIL"] = "facebook_deprecation_alternateEmail";
    TrackEvent["RESET_PASSWORD"] = "facebook_deprecation_openEmailApp";
    TrackEvent["FAQ_CREATE_PASSWORD"] = "faq_fbDeprecation_createPasswordLink";
    TrackEvent["TRACK_DATA"] = "TRACK_DATA";
})(TrackEvent || (TrackEvent = {}));
export const track = (event, payload) => {
    const trackData = { event };
    if (typeof payload === 'object') {
        Object.assign(trackData, payload);
    }
    if (isClient()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(trackData);
    }
};
//# sourceMappingURL=tracking.js.map